import ITransferState from 'redux/fileUpload/interfaces/iTransferState';

const completedEntries = (state: ITransferState) =>
  state.entries.filter((entry) => entry.completed);

export default completedEntries;
